<template>
    <div v-if="alert" class="col-12">
        <div
            class="alert alert-dismissible fade show text-white"
            :class="`alert-${alert.type}`"
            role="alert"
        >
            {{ alert.message }}
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
            >
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="col-sm-12 my-2">
        <div class="form-group my-1">
            <label for="files">
                გალერეა
                <small class="text-secondary">(1 ფოტო - მაქს: 1მბ)</small>
            </label>
            <input
                id="files"
                name="files"
                type="file"
                ref="fileInput"
                class="form-control"
                @change="uploadFiles"
                accept="image/*"
                multiple
            />
        </div>
    </div>
</template>

<script>
import { upload } from "../../Services/ApiService";

export default {
    data() {
        return {
            alert: {},
        };
    },
    methods: {
        uploadFiles() {
            const files = this.$refs.fileInput.files;
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append("files[]", files[i]);
            }

            const title = files.length > 1 ? "ფოტოები" : "ფოტო";

            this.message("info", `${title} იტვირთება, გთხოვთ დაელოდოთ...`);
            upload(formData)
                .then((res) => {
                    if (res.status === 200) {
                        let data = res.data.data;

                        document.querySelector('input[name="image"]').value =
                            data.mainImage;
                        document.querySelector(
                            'input[name="gallery_id"]'
                        ).value = data.galleryId || null;

                        this.message(
                            "success",
                            `${title} წარმატებით აიტვირთა.`
                        );

                        setTimeout(() => (this.alert = {}), 3000);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.message(
                        "danger",
                        `${title}ს ზომა დაშვებულზე მეტია. 1 ფაილი უნდა იყოს მაქსიმუმ 1მბ!`
                    );
                });
        },
        message(type, message) {
            this.alert.type = type;
            this.alert.message = message;
        },
    },
};
</script>
